export const WorkdayProjectDataTableConfig = {
  DefaultPageSize: 10,
  DefaultPageNumber: 1
}
